
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import CartButton from './CartButton';
import { LogOut, User } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

const AuthButtons = () => {
  const { user, loading, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  if (loading) {
    return (
      <div className="hidden md:flex items-center space-x-4">
        <CartButton />
        <div className="h-9 w-20 bg-gray-100 rounded-full animate-pulse"></div>
      </div>
    );
  }

  return (
    <div className="hidden md:flex items-center space-x-4">
      <CartButton />
      {user ? (
        <Button 
          variant="ghost" 
          onClick={handleLogout}
          className="rounded-full text-autocare-gray-dark hover:bg-red-50 hover:text-red-600 flex items-center gap-2"
        >
          <LogOut className="h-4 w-4" />
          تسجيل الخروج
        </Button>
      ) : (
        <>
          <Link to="/login">
            <Button variant="outline" className="rounded-full border-autocare-blue text-autocare-blue hover:bg-autocare-blue hover:text-white">
              تسجيل الدخول
            </Button>
          </Link>
          <Link to="/signup">
            <Button className="rounded-full bg-autocare-blue text-white hover:bg-autocare-blue-light">
              إنشاء حساب
            </Button>
          </Link>
        </>
      )}
    </div>
  );
};

export default AuthButtons;
